import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import PrivacyPopup from './PrivacyPopup';
import TermsPopup from './TermsPopup';
import RulesPopup from './RulesPopup';
import KYCPopup from './KYCPopup';
import ResponsibleGamePopup from './ResponsibleGamePopup';
import CommonPopup from './CommonPopup';
import Cookies from 'universal-cookie';
import { USER_API } from '../common/common';
import { postApi } from '../service';
import { Logout, getContactChannel } from '../common/Funcation';

const cookies = new Cookies()
const Footer = () => {
    const DD = useSelector((e: any) => e.domainDetails);
    const whatsappChannel = getContactChannel(DD, "whatsapp");
    const telegramChannel = getContactChannel(DD, "telegram");
    const facebookChannel = getContactChannel(DD, "facebook");
    const whatsappContact = whatsappChannel.values[0];
    const telegramContact = telegramChannel.values[0];
    const facebookContact = facebookChannel.values[0];
    const [privacyPopup, setPrivacyPopup] = useState(false)
    const [termsPopup, setTermsPopup] = useState(false)
    const [rulesPopup, setRulesPopup] = useState(false)
    const [kycPopup, setKycPopup] = useState(false)
    const [responsibleGamePopup, setResponsibleGamePopup] = useState(false)

    const downloadFile = () => {

        const imageUrl = `${process.env.REACT_APP_BASE_POINT}client.apk`;
        // Create a new XMLHttpRequest
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';

        xhr.onload = () => {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(xhr.response);
            a.download = 'client.apk'; // Set the desired file name
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };

        xhr.open('GET', imageUrl);
        xhr.send();

    };



    return (
        <>
            <div className='footer'>

                <div className=' footer_power'>
                    <div className="licence_embed">
                        <a onClick={downloadFile}>
                            <img src="/images/velki-clone/btn-android-dl.png" alt="Download APK" />
                        </a>
                        <p style={{ fontSize: "11.44px" }}>v1.11 - 2024/3/8 - 2.6MB</p>
                    </div>
                </div>

                {(whatsappChannel.showing || telegramChannel.showing || facebookChannel.showing) && (
                    <div className="social_tab" style={{ padding: "20.8px 0" }}>
                        {whatsappChannel.showing && (
                            <a
                                className="footer-social-link"
                                href={whatsappContact ? `https://wa.me/${String(whatsappContact).replace(/[^\d]/g, "")}` : undefined}
                                target="_blank"
                                rel="noreferrer"
                                aria-label="WhatsApp"
                                title={whatsappContact || "WhatsApp"}
                            >
                                <span className="footer-social-icon footer-social-icon--whatsapp" />
                                {/* {whatsappContact ? <span className="footer-social-text">{whatsappContact}</span> : null} */}
                            </a>
                        )}
                        {telegramChannel.showing && (
                            <a
                                className="footer-social-link"
                                href={telegramContact
                                    ? (/^https?:\/\//i.test(telegramContact) ? telegramContact : `https://t.me/${telegramContact}`)
                                    : undefined}
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Telegram"
                                title={telegramContact || "Telegram"}
                            >
                                <span className="footer-social-icon footer-social-icon--telegram" />
                                {/* {telegramContact ? <span className="footer-social-text">{telegramContact}</span> : null} */}
                            </a>
                        )}
                        {facebookChannel.showing && (
                            <a
                                className="footer-social-link"
                                href={facebookContact
                                    ? (/^https?:\/\//i.test(facebookContact) ? facebookContact : `https://facebook.com/${facebookContact}`)
                                    : undefined}
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Facebook"
                                title={facebookContact || "Facebook"}
                            >
                                <span className="footer-social-icon footer-social-icon--facebook" />
                                {/* {facebookContact ? <span className="footer-social-text">{facebookContact}</span> : null} */}
                            </a>
                        )}
                    </div>
                )}

                <ul className="policy-link">
                    <li>
                        <a onClick={() => setPrivacyPopup(true)} style={{ fontSize: "11.44px" }}>Privacy Policy</a>
                    </li>
                    <li>
                        <a onClick={() => setTermsPopup(true)} style={{ fontSize: "11.44px" }}>Terms and Conditions</a>
                    </li>
                    <li>
                        <a onClick={() => setRulesPopup(true)} style={{ fontSize: "11.44px" }}>Rules and Regulations</a>
                    </li>
                    <li>
                        <a onClick={() => setKycPopup(true)} style={{ fontSize: "11.44px" }}>KYC</a></li>
                    <li>
                        <a onClick={() => setResponsibleGamePopup(true)} style={{ fontSize: "11.44px" }}>Responsible Gaming</a>
                    </li>
                </ul>
            </div>








            {privacyPopup &&
                <CommonPopup
                    title={`Privacy Policy`}
                    OpenModal={privacyPopup}
                    closeModel={() => setPrivacyPopup(false)}
                    customclass="footerpopup"
                >
                    <PrivacyPopup />
                </CommonPopup>
            }

            {termsPopup &&
                <CommonPopup
                    title={`Terms & Conditions`}
                    OpenModal={termsPopup}
                    closeModel={() => setTermsPopup(false)}
                    customclass="footerpopup"
                >

                    <TermsPopup />
                </CommonPopup>
            }
            {rulesPopup &&
                <CommonPopup
                    title={`Rules and Regulations`}
                    OpenModal={rulesPopup}
                    closeModel={() => setRulesPopup(false)}
                    customclass="footerpopup"
                >

                    <RulesPopup />
                </CommonPopup>
            }
            {kycPopup &&
                <CommonPopup
                    title={`KYC`}
                    OpenModal={kycPopup}
                    closeModel={() => setKycPopup(false)}
                    customclass="footerpopup"
                >

                    <KYCPopup />
                </CommonPopup>
            }
            {responsibleGamePopup &&
                <CommonPopup
                    title={`Responsible Gaming`}
                    OpenModal={responsibleGamePopup}
                    closeModel={() => setResponsibleGamePopup(false)}
                    customclass="footerpopup"
                >
                    <ResponsibleGamePopup />
                </CommonPopup>
            }

        </>
    )
}

export default Footer